import React, { useEffect, useState } from 'react'
import { AiOutlineBook } from 'react-icons/ai';
import { MdBusiness } from 'react-icons/md';
import { FaUsers } from 'react-icons/fa';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const AdminDashboardCards = ({ group , dashboardAnalytics, loadingTeam}) => {
    const [dashboardCard , setDashboardCard] = useState([]);
    
        useEffect(()=>{
        let modulesLength = dashboardAnalytics?.modules?.length ?? 0
        let groupLength = dashboardAnalytics?.group?.groups ?? 0;
        let userLength = dashboardAnalytics?.group?.users ?? 0;

        setDashboardCard( [
            {
                id: 1,
                count: modulesLength,
                title: 'Courses',
                icons: <AiOutlineBook />
            },
            {
                id: 2,
                count: groupLength,
                title: 'SubGroups',
                icons: <MdBusiness />
            },
            {
                id: 3,
                count: userLength,
                title: 'Users',
                icons: <FaUsers />
            }
        ]);

        },[dashboardAnalytics])

    return (
        <>
       

          
        <div className="col-md-12 mb-2">
          <div className='datacardesign py-2'>
            <div className="row justify-content-between">
              <div className="col-md-5 d-flex align-items-center ">
                <div className='cardimages d-flex align-items-center gap-3 ps-3'>
                {loadingTeam ? 
                <Skeleton count={1} circle height="4.5vw" width="4.5vw" />  
                : <>
                  {
                  group.avatar ? (
                    <div className="groupcardesign m-0" style={{ height: "auto" }}>
                    <div className='avatarimg m-0' >
                        <img src={group.avatar} referrerPolicy={'no-referrer'} alt='' />
                    </div>
                    </div>
                    ) : (
                        <div className="usercardesign m-0" style={{ height: "auto" }}>
                            <div className='initials-placeholder'>
                            {group?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                        </div>
                        </div>
                    )
                  }
                  </>
                }

                <h4 className=" group-user-name m-0">{loadingTeam ? <Skeleton count={1} width="10vw" /> : <> {group.name} </> }</h4>
                </div>
              </div>
              <div className="col-md-7">
                  
                <div className="dashstatdata">
                {loadingTeam ? 
                <>
                  <div className="welcometext" >
                    <p><Skeleton width="5vw"/></p>
                    <h4><Skeleton width="5vw"/></h4>
                  </div>
                  <div className="welcometext" >
                    <p><Skeleton width="5vw"/></p>
                    <h4><Skeleton width="5vw"/></h4>
                  </div>
                  <div className="welcometext" >
                    <p><Skeleton width="5vw"/></p>
                    <h4><Skeleton width="5vw"/></h4>
                  </div>
                </>
                :
                <>
                {dashboardCard.map((edata, index) => (
                  <div className="welcometext" key={index+1} >
                    <p>{edata.title}</p>
                    <h4>{edata.count}</h4>
                  </div>
                  ))
                }
                </> }
                </div>
              </div>
            </div>
          </div>
        </div>

        </>
    )
}

export default AdminDashboardCards
